import { permissions } from '~/shared/lib'

const PIN_UNLOCK_PATH = permissions.AUTH.PIN.ROUTE
const PIN_SETUP_PATH = permissions.AUTH.PIN.SETUP.ROUTE
const SIGNIN_PATH = permissions.AUTH.SIGNIN.ROUTE
const AUTH_ROOT_PATH = permissions.AUTH.ROUTE

const AUTH_FLOW_ROUTE_PATHS = [
  SIGNIN_PATH,
  PIN_UNLOCK_PATH,
  PIN_SETUP_PATH,
] as const

function matchesRoutePath(path: string, routePath: string) {
  return path === routePath || path.startsWith(`${routePath}/`)
}

export function isPinUnlockRoute(path: string) {
  return path === PIN_UNLOCK_PATH
}

export function isPinSetupRoute(path: string) {
  return path === PIN_SETUP_PATH
}

export function isPinUiRoute(path: string) {
  return isPinUnlockRoute(path) || isPinSetupRoute(path)
}

export function isAuthFlowRoute(path: string) {
  return AUTH_FLOW_ROUTE_PATHS.some(routePath => matchesRoutePath(path, routePath))
}

export function isAuthSectionRoute(path: string) {
  return matchesRoutePath(path, AUTH_ROOT_PATH)
}

export function isAuthBootstrapSafeRoute(path: string) {
  return matchesRoutePath(path, SIGNIN_PATH)
    || matchesRoutePath(path, PIN_SETUP_PATH)
}

export function resolveSafePostAuthRedirect(redirect?: string) {
  if (!redirect || typeof redirect !== 'string') {
    return undefined
  }

  if (!redirect.startsWith('/') || redirect.startsWith('//')) {
    return undefined
  }

  if (isAuthSectionRoute(redirect)) {
    return undefined
  }

  return redirect
}

export function resolvePinUnlockRedirectTarget(options?: {
  currentPath?: string
  queryRedirect?: unknown
}) {
  const safeQueryRedirect = typeof options?.queryRedirect === 'string'
    ? resolveSafePostAuthRedirect(options.queryRedirect)
    : undefined

  if (safeQueryRedirect) {
    return safeQueryRedirect
  }

  const currentPath = options?.currentPath

  if (!currentPath || isAuthSectionRoute(currentPath)) {
    return permissions.WORKSPACE.ROUTE
  }

  return currentPath
}

export function getPinUnlockLocation(options?: {
  currentPath?: string
  queryRedirect?: unknown
  fullPath?: string
}) {
  const redirect = resolvePinUnlockRedirectTarget({
    currentPath: options?.fullPath ?? options?.currentPath,
    queryRedirect: options?.queryRedirect,
  })

  return {
    name: permissions.AUTH.PIN.PERMISSION,
    query: { redirect },
  }
}
